<template>
  <AisStateResults class="site-search-results">
    <template #default="{ results: { nbHits } }">
      <AisInfiniteHits>
        <template #default="{ items, isLastPage, refineNext, sendEvent }">
          <div class="site-search-results__count text-small">
            <SearchResultsCount
              :hits="nbHits"
              :is-te-reo="isTeReo"
            />
          </div>
          <ul class="site-search-results__list">
            <li
              v-for="item in items"
              :key="item.objectID"
            >
              <a
                class="site-search-results__result"
                :href="item.url"
                @click="sendEvent('click', item, 'Result Clicked')"
                @mouseup.stop
              >
                <SiteSearchResult :item="item" />
              </a>
            </li>
          </ul>
          <li
            v-if="!isLastPage"
            class="search__show-more load-more"
          >
            <MoeButton
              :label="trans('Load more results', !isTeReo)"
              :event-prevent-default="true"
              theme="secondary"
              rounded
              @handle-click="refineNext"
            />
          </li>
        </template>
      </AisInfiniteHits>
    </template>
  </AisStateResults>
</template>

<script>
import { AisStateResults, AisInfiniteHits } from 'vue-instantsearch/vue3/es';
import SiteSearchResult from './SiteSearchResult.vue';
import MoeButton from '../MoeButton/MoeButton.vue';
import SearchResultsCount from './SearchResultsCount.vue';
import { trans } from '../../utils/utils';

export default {
  name: 'SiteSearchResults',
  components: {
    AisStateResults,
    AisInfiniteHits,
    SiteSearchResult,
    MoeButton,
    SearchResultsCount,
  },
  props: {
    isTeReo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    trans,
  },
};
</script>

<style lang="scss">
.site-search-results {
  position: relative;

  &__list {
    list-style-type: none;
    margin: 0;
    padding: 0;

    @include breakpoint-tablet-down {
      padding: 0;
    }
  }

  &__count {
    position: sticky;
    top: 4.45rem;
    z-index: 1;
    padding: 1rem 3rem;
    margin-bottom: 1rem;
    color: $color-charcoal-xlight;
    background: $color-grey-s4;

    strong {
      color: $color-black;
      font-weight: 900;
    }

    @include breakpoint-tablet-down {
      padding-inline: 1.5rem;
    }
  }

  &__result {
    width: 100%;
    text-decoration: none;
    color: $color-black;
    padding: 0 3rem;
    box-sizing: border-box;

    @include breakpoint-tablet-down {
      padding: 0 1.5rem;
    }

    .ais-Snippet.text-small {
      @include text-tiny;

      font-weight: $font-weight-book;
    }

    mark {
      background: transparent;
      font-weight: $font-weight-black;
    }

    @include hover-focus-active {
      color: $color-blue-s3;
      border-color: transparent;
    }

    @include focus-active {
      @include focus-outline;

      /* stylelint-disable-next-line unit-disallowed-list */
      outline-offset: -3px;
    }
  }

  .load-more {
    display: none;
  }
}

.site-search .load-more {
  display: grid;
}
</style>
